import React from 'react';
import { PropTypes } from 'prop-types';
import { debounce } from 'lodash';

import {
  TooltipTop,
  TooltipBottom,
  TooltipRight,
  TooltipLeft,
  TooltipMessage,
  TooltipTrigger,
  TooltipSpan,
} from './components';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayTooltip: false,
    };
    this.triggerTooltip = this.triggerTooltip.bind(this);
  }

  triggerTooltip(status) {
    if (!this.props.hideHover) {
      if (!this.props.forceDisplay) {
        this.setState({ displayTooltip: status });
      }
    }
  }

  debouncedMouseOver = debounce(this.triggerTooltip, this.props.delay);

  tooltipComponents = {
    top: TooltipTop,
    bottom: TooltipBottom,
    right: TooltipRight,
    left: TooltipLeft,
  };

  render() {
    const {
      message, position, children, forceDisplay, locationTop,
    } = this.props;
    const { displayTooltip } = this.state;

    const TooltipComponent = this.tooltipComponents[position || 'top'];
    return (
      <TooltipSpan
        onMouseLeave={() => {
          this.triggerTooltip(false);
          this.debouncedMouseOver.cancel();
        }}
      >
        {(displayTooltip || forceDisplay) && (
          <TooltipComponent locationTop={locationTop}>
            <TooltipMessage>{message}</TooltipMessage>
          </TooltipComponent>
        )}
        <TooltipTrigger
          onMouseOver={() => this.debouncedMouseOver(true)}
          onFocus={() => this.debouncedMouseOver(true)}
        >
          {children}
        </TooltipTrigger>
      </TooltipSpan>
    );
  }
}

Tooltip.defaultProps = {
  position: 'top',
  forceDisplay: false,
  hideHover: false,
};

Tooltip.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  position: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  delay: PropTypes.number,
  hideHover: PropTypes.bool,
  forceDisplay: PropTypes.bool,
  locationTop: PropTypes.string,
};

Tooltip.defaultProps = {
  delay: 0,
  locationTop: null,
};

export default Tooltip;
